import { OLButton } from "OLButton";
import { OLModal } from "components/Tooltips/OLModal";
import { useMessage } from "hooks/intl";
import { useState } from "react";
import { AttributeDetails } from "./AttributeDetails";
import { ComplexAttribute } from "./ComplexAttribute";
import { useStyles } from "./styles";

export type Attribute = {
  [key: string]: string | number | Attribute | Attribute[];
};

interface Props {
  attributes: Attribute;
  showCount?: number;
}

export const AttributesDetails = ({ attributes, showCount }: Props) => {
  const { message } = useMessage();
  const [isCustomAttributesModalOpen, setIsCustomAttributesModalOpen] =
    useState(false);
  const classes = useStyles();
  const properties = Object.keys(attributes);
  const elementToShow = properties.slice(0, showCount || properties.length);
  const hiddenElementsCount = properties.length - (showCount || 0);
  const areHiddenElements =
    typeof showCount === "number" && hiddenElementsCount > 0;

  const handleShowAllClick = () => {
    const tooltip = document.querySelector('[role="tooltip"]');

    if (tooltip) {
      tooltip.classList.add(classes.hiddenTooltip);
    }
    setIsCustomAttributesModalOpen(true);
  };

  return (
    <>
      {elementToShow.map((property) => {
        return (
          <AttributeDetails
            attribute={{ value: attributes[property], name: property }}
          />
        );
      })}
      {areHiddenElements && (
        <OLButton className={classes.showMoreBtn} onClick={handleShowAllClick}>
          {message(
            { id: "showAllElements" },
            {
              elements: hiddenElementsCount,
            },
          )}
        </OLButton>
      )}
      <OLModal
        open={isCustomAttributesModalOpen}
        header={message({ id: "customAttributes" })}
        submitText={message({ id: "close" })}
        submitAction={() => setIsCustomAttributesModalOpen(false)}
        onClose={() => setIsCustomAttributesModalOpen(false)}
        modalWidth={700}
      >
        <div className={classes.attributesContainerModal}>
          {Object.keys(attributes).map((key, index) => {
            return (
              <ComplexAttribute
                attribute={{
                  name: key,
                  value: attributes[key],
                }}
              />
            );
          })}
        </div>
      </OLModal>
    </>
  );
};
